import { render, staticRenderFns } from "./consolidatedOrders.vue?vue&type=template&id=e558a47e&scoped=true&"
import script from "./consolidatedOrders.vue?vue&type=script&lang=js&"
export * from "./consolidatedOrders.vue?vue&type=script&lang=js&"
import style0 from "./consolidatedOrders.vue?vue&type=style&index=0&id=e558a47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e558a47e",
  null
  
)

export default component.exports